<div *ngIf='portalDataDashboardGlobalIndicatorData' class='indicator-container'>
  <app-portal-data-element-list-indicator-element-container
    *ngIf='portalDataDashboardGlobalIndicatorData.countriesDeployedNb'>
    <app-portal-data-element-list-indicator-element
      itemName='Country deployed'
      [nbDisplay]='portalDataDashboardGlobalIndicatorData.countriesDeployedNb'
    />
  </app-portal-data-element-list-indicator-element-container>
  <app-portal-data-element-list-indicator-element-container
    *ngIf='portalDataDashboardGlobalIndicatorData.pointOfSalesNb'>
    <app-portal-data-element-list-indicator-element
      itemName='Point of Sales'
      [nbDisplay]='portalDataDashboardGlobalIndicatorData.pointOfSalesNb'
    />
  </app-portal-data-element-list-indicator-element-container>
  <app-portal-data-element-list-indicator-element-container
    *ngIf='portalDataDashboardGlobalIndicatorData.deviceList.length !== 0'>
    <app-portal-data-element-list-indicator-element
      *ngFor='let device of portalDataDashboardGlobalIndicatorData.deviceList'
      [itemName]='device.name'
      [nbDisplay]='device.number'
      tooltipText='Hello Change me text'
    />
  </app-portal-data-element-list-indicator-element-container>
</div>
